import { requestApiSaga } from '@client/common/redux/api/sagas';
import {
  createRemoteRecordCleanUpSaga,
  REMOTE_RECORD_CLEAN_UP_DEBOUNCE,
} from '@client/common/redux/effects/createRemoteRecordCleanUpSaga';
import { reportError } from '@client/common/redux/errors/actions';
import { parseError } from '@client/common/utils/api/error';
import { Manufacturer } from '@client/manufacturer/api/Manufacturer';
import {
  fetchManufacturer,
  fetchManufacturerCleanUp,
  fetchManufacturerFulfilled,
  fetchManufacturerRejected,
  selectManufacturerRecords,
} from '@client/manufacturer/redux/manufacturer/redux';
import { AxiosResponse } from 'axios';
import { all, AllEffect, call, CallEffect, debounce, ForkEffect, put, PutEffect, takeLatest } from 'redux-saga/effects';

function* fetchManufacturerSaga(
  action: ReturnType<typeof fetchManufacturer>,
): Generator<CallEffect | PutEffect, void, AxiosResponse> {
  const manufacturerId = action.payload;

  try {
    const response = yield call(
      requestApiSaga,
      Manufacturer.fetch(manufacturerId),
    );
    yield put(
      fetchManufacturerFulfilled({
        manufacturerId,
        data: Manufacturer.mapResponseToState(response),
      }),
    );
  } catch (error) {
    yield put(fetchManufacturerRejected({ manufacturerId, error: parseError(error) }));
    yield put(reportError({ message: action.type, error, additionalData: { manufacturerId } }));
  }
}

export function* manufacturerSaga(): Generator<AllEffect<ForkEffect>, void> {
  yield all([
    takeLatest(fetchManufacturer.type, fetchManufacturerSaga),
    debounce(
      REMOTE_RECORD_CLEAN_UP_DEBOUNCE,
      [fetchManufacturerFulfilled.type, fetchManufacturerRejected.type],
      createRemoteRecordCleanUpSaga(
        selectManufacturerRecords,
        fetchManufacturerCleanUp.type,
      ),
    ),
  ]);
}
